import { useCallback } from "react";
import { IGroundEvent, IFullFlight } from "@vmosolutions/oc-interfaces";
import { Button, Grid } from "@mui/material";
import { TextField } from "src/components/FormikComponents/TextField";
import { useState } from "react";
import { useDispatch } from "react-redux";

// API calls
import AmplifyAPIWrapper, { INotifications } from "src/API/AmplifyAPIWrapper";

export interface ICommentFormProps {
  windowId: string;
  isFlight: boolean;
  eventId: string;
  //comments: IComment[];
  setLoadedFlight?: (flightValues: IFullFlight) => void;
  setLoadedGroundEvent?: (eventValues: IGroundEvent) => void;
  updateTabState?: (dirtyStatus: boolean) => void; // update parent with dirty status.
}

/**
 * A component for the user to input a flight comment
 * @param props - a full flight
 * @returns a component to input a flight comment
 */

export const EventCommentForm = (props: ICommentFormProps): JSX.Element => {
  const { isFlight, eventId, setLoadedFlight, setLoadedGroundEvent, updateTabState } = props;
  const dispatch = useDispatch();

  // const userId: string = useSelector((state: IRootState) => state.authentication.attributes._id);
  // const username: string = useSelector((state: IRootState) => state.authentication.attributes.email);

  // New comment added by User.
  const [comment, setComment] = useState<string | null>(null);

  const handleSave = useCallback(async (): Promise<void> => {
    if (isFlight) {
      const notifications: INotifications = {
        dispatch: dispatch,
        infoMessage: "Updating Flight Comments...",
        successMessage: "Flight Comments Successfully Updated",
        errorMessage: "Error: Unable to Update Flight Comments",
      };
      const response = await AmplifyAPIWrapper.Put<any>(`/flights/${eventId}`, { comment }, notifications);
      if (response?.newEvent?._id) setLoadedFlight(response?.newEvent);
    } else {
      const notifications: INotifications = {
        dispatch: dispatch,
        infoMessage: "Updating Ground Event Comments...",
        successMessage: "Ground Event Comments Successfully Updated",
        errorMessage: "Error: Unable to Update Ground Event Comments",
      };
      const response = await AmplifyAPIWrapper.Put<any>(`/groundEvents/${eventId}`, { comment }, notifications);
      if (response?._id) setLoadedGroundEvent(response);
    }
    if (updateTabState) updateTabState(false);
    setComment(null);
  }, [comment, dispatch, eventId, isFlight, setLoadedFlight, setLoadedGroundEvent, updateTabState]);

  return (
    <Grid container direction="column" className="comment_form">
      <Grid item>
        <TextField
          className="submit_textarea"
          label=""
          name="comment"
          value={comment}
          onChange={(event: any) => {
            const newComment = event?.target?.value ?? undefined;
            if (updateTabState) updateTabState(newComment !== undefined);
            setComment(newComment);
          }}
          // placeholder='...'
          multiline={true}
          maxRows="6"
          minRows="3"
          fullWidth={true}
        />
      </Grid>

      <Grid item className="buttons">
        <Button
          id={"clear_btn"}
          className="clear_comment"
          disabled={!comment}
          onClick={() => {
            if (updateTabState) updateTabState(false);
            setComment(null);
          }}
          color="primary"
        >
          Clear
        </Button>
        <Button
          id={"add_comment_btn"}
          className="submit_comment"
          disabled={!comment}
          onClick={handleSave}
          color="primary"
          autoFocus={true}
        >
          Add Comment
        </Button>
      </Grid>
    </Grid>
  );
};
